/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the first number by the second and multiply by 100. For example, 30 out of 120 is (30 ÷ 120) × 100 = 25%.`)
};

const es_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide el primer número entre el segundo y multiplica por 100. Por ejemplo, 30 de 120 es (30 ÷ 120) × 100 = 25%.`)
};

const de_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile die erste Zahl durch die zweite und multipliziere mit 100. Zum Beispiel sind 30 von 120 gleich (30 ÷ 120) × 100 = 25 %.`)
};

const nl_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel het eerste getal door het tweede en vermenigvuldig met 100. Bijvoorbeeld, 30 van de 120 is (30 ÷ 120) × 100 = 25%.`)
};

const fr_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez le premier nombre par le second puis multipliez par 100. Par exemple, 30 sur 120 donne (30 ÷ 120) × 100 = 25 %.`)
};

const it_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi il primo numero per il secondo e moltiplica per 100. Ad esempio, 30 su 120 è (30 ÷ 120) × 100 = 25%.`)
};

const pt_br2_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o primeiro número pelo segundo e multiplique por 100. Por exemplo, 30 de 120 é (30 ÷ 120) × 100 = 25%.`)
};

const pt_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o primeiro número pelo segundo e multiplique por 100. Por exemplo, 30 em 120 é (30 ÷ 120) × 100 = 25%.`)
};

const ja_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つ目の数を2つ目の数で割り、100を掛けます。例えば120のうち30は(30 ÷ 120) × 100 = 25%です。`)
};

const zh_pct_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用第一个数除以第二个数，再乘以 100。例如，120 中的 30 是 (30 ÷ 120) × 100 = 25%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq2_a", locale)
	if (locale === "en") return en_pct_hub_faq2_a(inputs)
	if (locale === "es") return es_pct_hub_faq2_a(inputs)
	if (locale === "de") return de_pct_hub_faq2_a(inputs)
	if (locale === "nl") return nl_pct_hub_faq2_a(inputs)
	if (locale === "fr") return fr_pct_hub_faq2_a(inputs)
	if (locale === "it") return it_pct_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq2_a(inputs)
	if (locale === "pt") return pt_pct_hub_faq2_a(inputs)
	if (locale === "ja") return ja_pct_hub_faq2_a(inputs)
	return zh_pct_hub_faq2_a(inputs)
};